import { connect } from 'react-redux';
import Dashboard from 'components/dashboard/Dashboard';
import { fetchData, readGDPRData } from 'data/dashboard/Dashboard.actions';
import { fetchNewAuctions } from 'data/auctions/Auctions.actions';

const mapStateToProps = state => ({
  data: state.dashboard.data,
  hasError:
    state.dashboard.error != null || state.dashboard.readGDPRError != null,
  lang: state.i18n.locale,
  loading: state.dashboard.fetching,
  loadingAuctions: state.auctions.fetching,
  newAuctions: state.auctions.newAuctions || [],
  party: state.app.userParty,
  partyType:
    state.app.user && state.app.lookups
      ? state.app.lookups.partyTypes.find(
          p => p.ID === state.app.user.PartyType
        )
      : null,
  membership:
    state.app.user && state.app.lookups
      ? state.app.lookups.memberships.find(
          p => p.ID === state.app.user.MembershipId
        )
      : null,
});

const mapDispatchToProps = dispatch => ({
  fetchData: () => dispatch(fetchData()),
  readGDPRData: () => dispatch(readGDPRData()),
  fetchNewAuctions: skipStep => {
    dispatch(fetchNewAuctions(skipStep));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
